export default __webpack_public_path__ + "static/cta-pattern-2-0116c00dd74147ffdfe8af3644369c46.png";